import { NotificationTabKey } from "../../model";
import { SCHEDULED, ACTIVE, EXPIRED, DELETED } from "../tabs/tabs.header";

type TabActions = {
  canView: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canReadConfirmation?: boolean; // Note: Modal confirmacao de leitura
};

export const getActionsForTab = (tab: NotificationTabKey): TabActions => {
  switch (tab) {
    case SCHEDULED:
      return {
        canReadConfirmation: false,
        canView: false,
        canEdit: true,
        canDelete: true,
      };
    case ACTIVE:
      return {
        canReadConfirmation: true,
        canView: false,
        canEdit: true,
        canDelete: true,
      };
    case EXPIRED:
      return {
        canReadConfirmation: true,
        canView: true,
        canEdit: false,
        canDelete: false,
      };
    case DELETED:
      return { canView: true, canEdit: false, canDelete: false };
    default:
      return { canView: false, canEdit: false, canDelete: false };
  }
};
